import Vue from 'vue';
import { formatDate } from '@/shared/utils';

Vue.filter('formatDate', formatDate);